import React, { Fragment, memo } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  checkDoctorDept,
  getDragDropStyle,
  isHiddenInPrint,
  itemSettingStyle,
  itemTitleStyle,
  lineHeightStyle,
  medicineFullName,
  organizeParentChild,
} from '../../../utils/helpers';
import ChiefComplainDeleteBtn from './chiefComplainDeleteBtn';
import DrugInteractionAlert from './DrugInteractionAlert';
import EditSelectedMedicineItem from './editSelectedMedicineItem';
import SelectedMedicineSchedule from './selectedMedicineSchedule';

const RxView = ({
  selectedMedicines,
  setSelectedMedicines,
  instructions,
  setInstructions,
  setShowRx,
  prescriptionItems,
  editMedicineId,
  setEditMedicineId,
  element,
  type,
  isHistoryPage = false,
  medicineType = '',
  interactionData = {},
  acknowledgedPairs = new Set(),
  onAcknowledgeInteraction = () => {},
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const specialties = useSelector(
    (state) => state.specialtyReducer.specialties,
  );
  const medicineTypes = useSelector(
    (state) => state.medicineTypeReducer.medTypes,
  );
  const isGynecology = checkDoctorDept(
    'gynecology',
    userInfo?.speciality?.[0],
    specialties,
  );
  const isActivePatientOption =
    isGynecology && userInfo?.doctorDetails?.isGyneRxView;

  const allGenericNamesInRx = selectedMedicines
    .map((m) => m.genericName)
    .filter(Boolean);

  const showInteractions = !isHistoryPage && type !== 'print';

  const renderInteractionAlert = (item) => {
    if (!showInteractions || !item.genericName) return null;
    return (
      <DrugInteractionAlert
        medicine={item}
        allGenericNames={allGenericNamesInRx}
        interactions={interactionData[item.genericName] || []}
        acknowledgedPairs={acknowledgedPairs}
        onAcknowledge={onAcknowledgeInteraction}
      />
    );
  };

  const isMedTypeName = prescriptionItems?.items?.rx?.isMedTypeName || false;
  const showMedicineName = useSelector(
    (state) => state.prescriptionReducer.prescriptionInfo.showMedicineName,
  );
  console.log('jakir.........', showMedicineName === 'genericName');

  const handleSelectedMedicine = (
    fieldName,
    medicineId,
    value,
    itemDetailIndex,
  ) => {
    const objIndex = selectedMedicines.findIndex(
      (medicine) => medicine.id === medicineId,
    );

    if (objIndex === -1) {
      return '';
    }

    switch (fieldName) {
      case 'quantities':
      case 'quantitiesField':
      case 'quantityUnit':
      case 'quantity':
      case 'route':
      case 'schedule':
      case 'scheduleUnit':
        selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][fieldName] =
          value;
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'duration':
        selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][fieldName] =
          value;
        if (value === '') {
          selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][
            'durationUnit'
          ] = '';
        }
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'durationUnit':
        selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][fieldName] =
          value;
        if (value === '' || value === 'চলবে') {
          selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][
            'duration'
          ] = '';
        }
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'quantitiesData':
        selectedMedicines[objIndex] = value;
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'instructions':
        selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][fieldName] =
          [
            ...new Set([
              ...selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][
                fieldName
              ],
              value,
            ]),
          ];
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'instructionRemove':
        selectedMedicines[objIndex]['itemDetails'][itemDetailIndex][
          'instructions'
        ] = value;
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'itemDetails':
        selectedMedicines[objIndex]['itemDetails'] = value;
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'similarMedicine':
        let replacedData = selectedMedicines[objIndex];
        replacedData.name = value?.brandName;
        replacedData.id = value?.id;
        replacedData.nameType = 'brandName';
        replacedData.brandName = value?.brandName;
        replacedData.companyName = value?.companyName;
        replacedData.genericName = value?.genericName;
        replacedData.strength = value?.strength;
        replacedData.type = value?.type;
        replacedData.altName = value?.altName;
        replacedData.createdBy = value?.createdBy;
        selectedMedicines[objIndex] = replacedData;
        setSelectedMedicines([...selectedMedicines]);
        break;
      case 'medicineType':
        selectedMedicines[objIndex]['type'] = value;
        selectedMedicines[objIndex]['isChangeFormat'] = true;
        setSelectedMedicines([...selectedMedicines]);
        break;
      default:
    }
  };

  const medicineUpdated = (updatedData, index) => {
    selectedMedicines[index] = updatedData;
    setSelectedMedicines([...selectedMedicines]);
  };

  const deleteMedicine = (itemName, medicineId) => {
    const updatedResult = selectedMedicines.filter(
      (medicine) =>
        medicine.id !== medicineId && medicine.parentId !== medicineId,
    );
    setSelectedMedicines(updatedResult);
  };

  const selectedMedicineRow = (items) =>
    items.map((item, index) => {
      let objIndex = selectedMedicines.findIndex(
        (medicine) => medicine.id === item.id,
      );
      return (
        <EditSelectedMedicineItem
          item={item}
          itemIndexNo={objIndex}
          key={index}
          medicineUpdated={medicineUpdated}
          showMedicineName={showMedicineName}
          instructions={instructions}
          setInstructions={setInstructions}
          handleSelectedMedicine={handleSelectedMedicine}
          setEditMedicineId={setEditMedicineId}
        />
      );
    });

  let styles = {
    listStyle: 'none',
  };
  if (type !== 'print') {
    styles.minHeight = '200px';
  }

  const rxWhite = element.lineDraw ? 'rx-white' : '';
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = reorder(
      selectedMedicines,
      result.source.index,
      result.destination.index,
    );
    setSelectedMedicines(reorderedItems);
  };

  // this function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getRxGenericName = (item) => {
    if (
      element?.showGeneric &&
      item?.genericName &&
      item?.nameType !== 'genericName'
    ) {
      return (
        <span style={{ color: '#5a5959', fontStyle: 'italic' }}>
          ({`${item?.genericName}`})
        </span>
      );
    } else {
      return '';
    }
  };

  const getRomanSl = (sl) => {
    const romanMap = [
      'i',
      'ii',
      'iii',
      'iv',
      'v',
      'vi',
      'vii',
      'viii',
      'ix',
      'x',
    ];
    return romanMap[sl - 1] || '';
  };

  const styleObj = () => {
    let gapValue = '1.5rem';
    if (element?.marginBottom) {
      const v = parseFloat(element?.marginBottom?.value);
      if (v > 0) gapValue = `${v}${element?.marginBottom?.unit || 'px'}`;
    }
    let css = {
      ...lineHeightStyle('rx', prescriptionItems),
      marginBottom: '2rem',
      '--item-gap': gapValue,
    };
    if (selectedMedicines.length === 0) {
      css.marginBottom = '4rem';
    }
    return css;
  };

  const getMedicineTypeUsed = () => {
    console.log('medicineType: ', medicineType);

    if (isHistoryPage) {
      if (medicineType && medicineType === 'genericName') {
        return 'genericName';
      } else {
        return 'brandName';
      }
    } else {
      if (showMedicineName === 'genericName') {
        return 'genericName';
      } else {
        return 'brandName';
      }
    }
  };

  return (
    <div
      className={`row item-row selected-med-view`}
      key={`rx`}
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={styleObj()}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'rx') ? 'item-title-hide' : ''
        }`}
        style={itemTitleStyle(prescriptionItems?.items?.rx?.titleStyle || {})}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowRx(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Rx</span>
        )}
      </span>
      {isActivePatientOption ? (
        <Fragment>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-wife">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="droppable-wife"
                >
                  {selectedMedicines?.filter(
                    (item) => item.gynePatType === 'wife',
                  )?.length > 0 && <b>For Wife:</b>}
                  {organizeParentChild(selectedMedicines)
                    ?.filter((item) => item.gynePatType === 'wife')
                    .map((item, index) => (
                      <Fragment>
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Row
                              className="selected-medicine-row"
                              key={item.id}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getDragDropStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                              )}
                            >
                              <Col
                                className={`medicine-schedule-parent `}
                                {...(!isHistoryPage
                                  ? {
                                      onClick: (e) => {
                                        if (
                                          e.target.closest('[data-interaction-alert]') ||
                                          e.target.closest('.modal') ||
                                          e.target.closest('.modal-backdrop')
                                        ) return;
                                        setEditMedicineId(item?.id);
                                      },
                                    }
                                  : {})}
                              >
                                <div
                                  className={`text-left ${
                                    item.parentId ? 'child-medicine' : ''
                                  }`}
                                >
                                  <span
                                    className={
                                      element?.showGeneric ? 'bold' : ''
                                    }
                                    style={itemSettingStyle(
                                      prescriptionItems?.items?.rx?.itemStyle ||
                                        {},
                                    )}
                                  >
                                    {renderInteractionAlert(item)}
                                    {item?.parentId
                                      ? getRomanSl(item.sl)
                                      : index + 1}
                                    .{' '}
                                    {medicineFullName(
                                      item,
                                      'original',
                                      medicineTypes,
                                      isMedTypeName,
                                      getMedicineTypeUsed() === 'genericName'
                                        ? true
                                        : false,
                                    )}{' '}
                                    {getRxGenericName(item)}
                                    {item?.alterMedicine &&
                                      medicineFullName(
                                        item.alterMedicine,
                                        'alter',
                                        medicineTypes,
                                        isMedTypeName,
                                        getMedicineTypeUsed() === 'genericName'
                                          ? true
                                          : false,
                                      )}{' '}
                                    {item?.alterMedicine &&
                                      getRxGenericName(item?.alterMedicine)}
                                  </span>
                                </div>
                                {item?.itemDetails?.map((data, index) => {
                                  return (
                                    <SelectedMedicineSchedule
                                      data={data}
                                      item={item}
                                      typeName={item?.type}
                                      element={element}
                                      rxWhite={rxWhite}
                                      prescriptionItems={prescriptionItems}
                                      setEditMedicineId={setEditMedicineId}
                                    />
                                  );
                                })}
                              </Col>
                              <Col
                                md={1}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}
                              >
                                {!isHistoryPage && (
                                  <ChiefComplainDeleteBtn
                                    action={deleteMedicine}
                                    itemName={'rx'}
                                    delId={item.id}
                                  />
                                )}
                              </Col>
                              {editMedicineId === item.id &&
                                !isHistoryPage &&
                                selectedMedicineRow(
                                  selectedMedicines.filter(
                                    (medicine) => medicine.id === item.id,
                                  ),
                                )}
                            </Row>
                          )}
                        </Draggable>
                      </Fragment>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-husband">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="droppable-husband"
                >
                  {selectedMedicines?.filter(
                    (item) => item.gynePatType === 'husband',
                  )?.length > 0 && <b>For Husband:</b>}
                  {organizeParentChild(selectedMedicines)
                    ?.filter((item) => item.gynePatType === 'husband')
                    .map((item, index) => (
                      <Fragment>
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Row
                              className="selected-medicine-row"
                              key={item.id}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getDragDropStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                              )}
                            >
                              <Col
                                className={`medicine-schedule-parent `}
                                {...(!isHistoryPage
                                  ? {
                                      onClick: (e) => {
                                        if (
                                          e.target.closest('[data-interaction-alert]') ||
                                          e.target.closest('.modal') ||
                                          e.target.closest('.modal-backdrop')
                                        ) return;
                                        setEditMedicineId(item?.id);
                                      },
                                    }
                                  : {})}
                              >
                                <div
                                  className={`text-left ${
                                    item.parentId ? 'child-medicine' : ''
                                  }`}
                                >
                                  <span
                                    className={
                                      element?.showGeneric ? 'bold' : ''
                                    }
                                    style={itemSettingStyle(
                                      prescriptionItems?.items?.rx?.itemStyle ||
                                        {},
                                    )}
                                  >
                                    {renderInteractionAlert(item)}
                                    {item?.parentId
                                      ? `${getRomanSl(item.sl)}`
                                      : index + 1}
                                    .{' '}
                                    {medicineFullName(
                                      item,
                                      'original',
                                      medicineTypes,
                                      isMedTypeName,
                                      getMedicineTypeUsed() === 'genericName'
                                        ? true
                                        : false,
                                    )}{' '}
                                    {getRxGenericName(item)}
                                    {item?.alterMedicine &&
                                      medicineFullName(
                                        item.alterMedicine,
                                        'alter',
                                        medicineTypes,
                                        isMedTypeName,
                                        getMedicineTypeUsed() === 'genericName'
                                          ? true
                                          : false,
                                      )}{' '}
                                    {item?.alterMedicine &&
                                      getRxGenericName(item?.alterMedicine)}
                                  </span>
                                </div>
                                {item?.itemDetails?.map((data, index) => {
                                  return (
                                    <SelectedMedicineSchedule
                                      data={data}
                                      item={item}
                                      typeName={item?.type}
                                      element={element}
                                      rxWhite={rxWhite}
                                      prescriptionItems={prescriptionItems}
                                      setEditMedicineId={setEditMedicineId}
                                    />
                                  );
                                })}
                              </Col>
                              <Col
                                md={1}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}
                              >
                                {!isHistoryPage && (
                                  <ChiefComplainDeleteBtn
                                    action={deleteMedicine}
                                    itemName={'rx'}
                                    delId={item.id}
                                  />
                                )}
                              </Col>
                              {editMedicineId === item.id &&
                                !isHistoryPage &&
                                selectedMedicineRow(
                                  selectedMedicines.filter(
                                    (medicine) => medicine.id === item.id,
                                  ),
                                )}
                            </Row>
                          )}
                        </Draggable>
                      </Fragment>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Fragment>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={`droppable ${
                  userInfo?.email === 'shahreerdr@gmail.com'
                    ? 'shahreer-rx'
                    : ''
                }`}
              >
                {organizeParentChild(selectedMedicines)?.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <Row
                        className="selected-medicine-row"
                        key={item.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getDragDropStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        )}
                      >
                        <Col
                          className={`medicine-schedule-parent `}
                          {...(!isHistoryPage
                            ? {
                                onClick: (e) => {
                                  if (
                                    e.target.closest('[data-interaction-alert]') ||
                                    e.target.closest('.modal') ||
                                    e.target.closest('.modal-backdrop')
                                  ) return;
                                  setEditMedicineId(item?.id);
                                },
                              }
                            : {})}
                        >
                          <div
                            className={`text-left ${
                              item.parentId ? 'child-medicine' : ''
                            }`}
                          >
                            <span
                              className={element?.showGeneric ? 'bold' : ''}
                              style={itemSettingStyle(
                                prescriptionItems?.items?.rx?.itemStyle || {},
                              )}
                            >
                              {renderInteractionAlert(item)}
                              {item?.parentId
                                ? `${getRomanSl(item.sl)}`
                                : item.serial}
                              .{' '}
                              {medicineFullName(
                                item,
                                'original',
                                medicineTypes,
                                isMedTypeName,
                                getMedicineTypeUsed() === 'genericName'
                                  ? true
                                  : false,
                              )}{' '}
                              {getRxGenericName(item)}
                              {item?.alterMedicine &&
                                medicineFullName(
                                  item.alterMedicine,
                                  'alter',
                                  medicineTypes,
                                  isMedTypeName,
                                )}{' '}
                              {item?.alterMedicine &&
                                getRxGenericName(item?.alterMedicine)}
                            </span>
                          </div>
                          {item?.itemDetails?.map((data, index) => {
                            return (
                              <SelectedMedicineSchedule
                                data={data}
                                item={item}
                                typeName={item?.type}
                                element={element}
                                rxWhite={rxWhite}
                                prescriptionItems={prescriptionItems}
                                setEditMedicineId={setEditMedicineId}
                              />
                            );
                          })}
                        </Col>
                        <Col
                          md={1}
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                          }}
                        >
                          {!isHistoryPage && (
                            <ChiefComplainDeleteBtn
                              action={deleteMedicine}
                              itemName={'rx'}
                              delId={item.id}
                            />
                          )}
                        </Col>
                        {editMedicineId === item.id &&
                          !isHistoryPage &&
                          selectedMedicineRow(
                            selectedMedicines.filter(
                              (medicine) => medicine.id === item.id,
                            ),
                          )}
                      </Row>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </div>
  );
};

export default memo(RxView);
